import { AbstractInteractorTool } from './tools';
import { Wall } from "../mdl/Wall";
import { WallAddition } from "../mdl/WallAddition";
import { WallOpening } from "../mdl/WallOpening";
import { CoordinatesType } from "@egr/wcf/modules/core/view/View";
import { SceneElement } from '@egr/wcf/modules/core/mdl';
export class InsertWallAddition extends AbstractInteractorTool {
    /**
     * Inserts a wallpicture / whiteboard.
     * pImageTypes:
     * 0 -> 3:2
     * 1 -> 2:3
     * 2 -> 1:1
     * 3 -> whiteBoard
     * 4 -> individual
     */
    constructor(pRoomManager, pType, pWidth = 800, pHeight = 600, pKeepRatio = false, pImageType = 0, pFrameWidth = 0.015, pFrameColor = '#aaaaaa', pSuspensionHeight = 1.2, pmatCategory = 'color', pmatValue = '#aaaaaa') {
        super(pRoomManager);
        this.mType = pType;
        this.mWall = null;
        this.mPickedPos = null;
        this.mWidth = pWidth;
        this.mHeight = pHeight;
        this.mKeepRatio = pKeepRatio;
        this.mImageType = pImageType;
        this.mFrameWidth = pFrameWidth;
        this.mFrameColor = pFrameColor;
        this.mSuspensionHeigth = pSuspensionHeight;
        this.mmatCategory = pmatCategory;
        this.mmatValue = pmatValue;
    }
    hasToStart() {
        let tSel = this.mRoomManager.app.model.selection;
        if (tSel.length == 1) {
            if (tSel[0] instanceof Wall || tSel[0] instanceof WallOpening || tSel[0] instanceof WallAddition) {
                if (tSel[0] instanceof Wall) {
                    this.mWall = tSel[0];
                    this.finish();
                    return (false);
                }
                if (tSel[0] instanceof WallOpening) {
                    let tWE = tSel[0];
                    if (tWE.wall != null) {
                        this.mWall = tWE.wall;
                        this.finish();
                        return (false);
                    }
                }
                if (tSel[0] instanceof WallAddition) {
                    let tWE = tSel[0];
                    if (tWE.wall != null) {
                        this.mWall = tWE.wall;
                        this.finish();
                        return (false);
                    }
                }
            }
            return (true);
        }
        return (true);
    }
    stop() {
        super.stop();
    }
    handlePointerDown(pEvent, pState) {
        super.handlePointerDown(pEvent, pState);
        if (!pState.isPrimaryPointer(pEvent)) {
            return;
        }
    }
    handlePointerUp(pEvent, pState) {
        if (!pState.isPrimaryPointer(pEvent)) {
            return;
        }
        let tPointer = pState.pointers.get(pEvent.pointerId);
        if (tPointer == null)
            return;
        let tElement = this.getPickedElement(tPointer.position, !tPointer.isMousePointer, undefined);
        if (tElement == null ||
            (!(tElement instanceof Wall) && !(tElement instanceof WallOpening))) {
            this.finish();
            return;
        }
        if (tElement instanceof WallOpening) {
            if (tElement.wall != null) {
                this.mWall = tElement.wall;
                this.mPickedPos = null;
            }
        }
        else if (tElement instanceof Wall) {
            this.mWall = tElement;
        }
        this.finish();
    }
    handlePointerMove(pEvent, pState) {
        if (!pState.isPrimaryPointer(pEvent) && !pState.isMouseHoverPointer(pEvent))
            return;
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    startPos(pPos) {
        //
    }
    updatePointerPosition(pPos) {
        //
    }
    finish() {
        if (this.mWall == null) {
            this.stop();
            return;
        }
        if (this.mType == "PictureFrame") {
            this.mRoomManager.insertPictureFrame(this.mWall, this.mPickedPos, this.mWidth, this.mHeight, this.mKeepRatio, this.mImageType, this.mFrameWidth, this.mFrameColor, this.mSuspensionHeigth, this.mmatCategory, this.mmatValue);
        }
        else {
            this.mRoomManager.insertWallAddition(this.mType, this.mWall, this.mPickedPos, this.mWidth, this.mHeight, this.mKeepRatio, this.mImageType);
        }
        this.stop();
    }
    getPickedElement(pPos, pUseFrustum, rPickPos) {
        let tView = this.mView;
        if (tView == null)
            tView = this.mRoomManager.hoverView;
        if (tView == null)
            return (null);
        let tPickInfo = null;
        if (pUseFrustum)
            tPickInfo = tView.pickSceneWithFrustum(pPos, 30, 30, CoordinatesType.Client);
        else
            tPickInfo = tView.pickScene(pPos, CoordinatesType.Client);
        if (tPickInfo != null && tPickInfo.hit && tPickInfo.pickedMesh != null) {
            this.mPickedPos = tPickInfo.pickedPoint;
            if (this.mPickedPos != null)
                this.mPickedPos.y = 0;
            return (SceneElement.FromNode(tPickInfo.pickedMesh, true));
        }
        return (null);
    }
}
